/**
 * AccessDenied — French 403 denial screen.
 * Rendered by ProtectedRoute when the user lacks the required role.
 * No native dialogs — no window.alert/confirm/prompt.
 */

import { useNavigate } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import Button from '../ui/Button';

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#EAF4FB] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100">
            <ShieldOff size={32} className="text-red-600" />
          </span>
        </div>

        <h1 className="text-2xl font-playfair font-bold text-[#17386E] mb-2">
          Accès refusé
        </h1>
        <p className="text-gray-600 font-montserrat text-sm mb-8">
          Vous n'avez pas les permissions nécessaires pour accéder à cette page.
        </p>

        <Button variant="secondary" onClick={() => navigate(-1)}>
          Retour
        </Button>
      </div>
    </div>
  );
};

export default AccessDenied;
